<template>
    <div class="home">
     
      <RolesContenedorComponent />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import RolesContenedorComponent from '@/components/RolesContenedorComponent.vue'
  
  export default {
    name: 'UserView',
    components: {
        RolesContenedorComponent
    }
  }
  </script>